import { bool, shape, string } from "prop-types";
import slugify from "slugify";
import { simpleStripTags } from "../../common/simpleStripTags.js";

export const eventShape = shape({
  title: string.isRequired, // html
  characteristic: string.isRequired,
  description: string.isRequired, // html
  color: string.isRequired,
  isVisible: bool.isRequired,
  year: string.isRequired,
});

export const eventId = (event) => {
  const slug =
    "event-" +
    slugify(
      `${event.year}-${event.title}-${simpleStripTags(
        event.description,
      ).substring(0, 20)}`,
      {
        remove: /[*+~.()'"!:@,;/]/g,
        strict: true,
      },
    );
  return event ? slug : undefined;
};
